import { IStepDataDef } from 'src/app/model/view/iqualification-def';

export class OrientationDefinitions {

    public static DEF_OR_IMP_HEARING(): IStepDataDef {
        return { code: 'DEF_OR_IMP_HEARING_TEACHING', name: 'Dövhet eller hörselskada' };
    }

    public static DEF_OR_IMP_VISUALLY(): IStepDataDef {
        return { code: 'DEF_OR_IMP_VISUALLY_TEACHING', name: 'Synskada' };
    }

    public static SEVERE_LANG_DISORDER(): IStepDataDef {
        return { code: 'SEVERE_LANG_DISORDER_TEACHING', name: 'Grav språkstörning' };
    }

    public static RETARDATION(): IStepDataDef {
        return { code: 'RETARDATION_TEACHING', name: 'Intellektuell funktionsnedsättning' };
    }

    public static ACCORDING_TO_SPECIAL_TEACHER_DEGREE_TEACHING(): IStepDataDef {
        return { code: 'ACCORDING_TO_SPECIAL_TEACHER_DEGREE_TEACHING', name: 'Som speciallärarexamen avser' };
    }
}
